import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Settings, Bell, User, Save } from 'lucide-react';
import { Button } from '@/components/ui/button';

const CustomizationModule = () => {
  const [notifications, setNotifications] = useState({
    email: true,
    sms: false,
    push: true
  });

  return (
    <div className="space-y-6">
      <Card className="bg-[#12172e] border-cyan-500/30 hover:border-cyan-500/50 transition-all text-white">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <User size={20} />
            User Profile
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            <input
              type="text"
              placeholder="Display Name"
              className="w-full bg-slate-900 border-cyan-500/30 hover:border-cyan-500/50 transition-colors text-white rounded px-3 py-2"
            />
            <input
              type="text"
              placeholder="Phone"
              className="w-full bg-slate-900 border-cyan-500/30 hover:border-cyan-500/50 transition-colors text-white rounded px-3 py-2"
            />
          </div>
        </CardContent>
      </Card>

      <Card className="bg-[#12172e] border-cyan-500/30 hover:border-cyan-500/50 transition-all text-white">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Bell size={20} />
            Notifications
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {Object.entries(notifications).map(([key, value]) => (
              <label key={key} className="flex items-center justify-between p-3 bg-slate-800 rounded">
                <span className="text-sm capitalize">{key}</span>
                <input
                  type="checkbox"
                  checked={value}
                  onChange={(e) => setNotifications({...notifications, [key]: e.target.checked})}
                  className="rounded"
                />
              </label>
            ))}
          </div>
        </CardContent>
      </Card>

      <Button onClick={() => alert('Settings saved!')} className="w-full">
        <Save size={16} className="mr-2" />
        Save Settings
      </Button>
    </div>
  );
};

export default CustomizationModule;
